module.exports = __webpack_public_path__ + "cancellara-dist/img/beneficy.c5b36c2d.png";